import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { xhrApiGetToken } from "../utilities/xhr-api";

import {
	xhrGlobalGetModalities,
} from "../utilities/xhr-global";
import toastUtil from "../utilities/toast-util";
import { xhrWadoGetToken, xhrWadoGetSeries, xhrWadoGetInstances } from "../utilities/xhr-wado";

 
export const DicomViewer = ({mode, tenantId, studyUids, modality, 
	outerToken, compareStudyUids}) => {

	modality = modality?.toUpperCase();

	const meddreamName = 'meddream';
	const ohifName = 'ohif';
	const ohifV3Name = 'ohif-v3';
	
	const dispatch = useDispatch();

	const [modeInner, setModeInner] = React.useState(mode ?? ohifV3Name);
	const [tenantIdInner, setTenantIdInner] = React.useState(tenantId);
	const [studyUidsInner, setStudyUidsInner] = React.useState([...new Set(studyUids)]);
	const [modalityInner, setModalityInner] = React.useState(modality);
	const [compareStudyUidsInner, setCompareStudyUidsInner] = React.useState([...new Set(compareStudyUids)]);

	React.useEffect(()=>{
		if(studyUids?.length > 0){
			setStudyUidsInner([...new Set(studyUids)]?.sort());
			setCompareStudyUidsInner([...new Set(compareStudyUids)]?.sort());
		}
		else{
			if(compareStudyUids?.length > 0){
				setStudyUidsInner([...new Set(compareStudyUids)]?.sort());
				setCompareStudyUidsInner([]);
			}
		}
	},[studyUids, compareStudyUids])

	React.useEffect(()=>{
		setModeInner(mode ?? ohifV3Name);
	},[mode])
	
	React.useEffect(()=>{
		setTenantIdInner(tenantId);
	},[tenantId])

	React.useEffect(()=>{
		setStudyUidsInner([...new Set(studyUids)]);
	},[studyUids])
	
	React.useEffect(()=>{
		setModalityInner(modality);
	},[modality])
	
	React.useEffect(()=>{
		setCompareStudyUidsInner([...new Set(compareStudyUids)]);
	},[compareStudyUids])

	const token = useSelector((state) => state.session.token);
	const userInfo = useSelector((state) => state.session.userInfo);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	const currentLanguage = useSelector((state) => state?.session?.userPreferences?.language);
	const [moduleId, setModuleId] = React.useState("viewerModule" + Math.random() * 1000);

	const [url, setUrl] = React.useState("");
	const [urlExtra, setUrlExtra] = React.useState("");
	const [tokenApi, setTokenApi] = React.useState();

	React.useEffect(() => {
		if (outerToken?.length > 0) {
			Promise.all([xhrApiGetToken(outerToken, tenantIdInner)]).then((values) => {
				setTokenApi(values[0]?.result?.data);
			});
		}
	}, [tenantIdInner, outerToken]);
	
	const compMedMaxSeries = useSelector((state) => state?.session?.userPreferences?.meddreamMaxSeries??16);
	const [compMed, setCompMed] = React.useState();
	const [compMedReady, setCompMedReady] = React.useState(false);
	const [compMedReadyCheck, setCompMedReadyCheck] = React.useState(false);
	const [compMedPositionCheck, setCompMedPositionCheck] = React.useState(false);
	const [compMedSeries, setCompMedSeries] = React.useState([[],[]]);
	const [compMedInstances, setCompMedInstances] = React.useState([[],[]]);
	const [compMedSeriesIndex, setCompMedSeriesIndex] = React.useState({ main: [-1,-1], compare: [-1,-1]});
	const [compMedLayout, setCompMedLayout] = React.useState({ main: [1,1], compare: [1,1]} );

	const compare = compareStudyUidsInner?.filter(x => !studyUidsInner.includes(x)).length > 0;

	const [compMedLayoutHover, setCompMedLayoutHover] = React.useState([0,0]);
	const [layoutSelector, setLayoutSelector] = React.useState(false);
	const [layoutPanel, setLayoutPanel] = React.useState(true);



	React.useEffect(()=>{
		if(tenantIdInner > 0 && token?.length > 0 && !(tokenApi?.length > 0)){
			//console.warn('medDream-xhrApiGetToken');
			Promise.all([xhrApiGetToken(token, tenantIdInner)]).then((values) => {
				setTokenApi(values[0]?.result?.data)
			});
		}
	},[tenantIdInner, token])

	const [allModalities, setAllModalities] = React.useState([]);
	React.useEffect(() => {
		let mountedRef = true;
		
		const effectPromise = async () => {
			var data = await xhrGlobalGetModalities(token);
			toastUtil({ currentLanguage, data });
			if (!mountedRef) return null;
			setAllModalities(data?.result?.data);
		}
		effectPromise();
		return () => {
			mountedRef = false;
		};
	}, [userPermissions]);
	
	React.useEffect(()=>{
		if(tenantIdInner > 0 && studyUidsInner?.length > 0 && tokenApi?.length > 0){
			if(modeInner === ohifName){
				setCompMedReady(true);
				let urlTemp = "";
				if (studyUidsInner?.length === 1) {
					urlTemp = `${process.env.REACT_APP_VIEWER_URL}/${studyUidsInner[0]}?tk=${tokenApi}`;
				} else if (studyUidsInner?.length >= 2) {
					let firstRecord = studyUidsInner[0];
					let reststudyUids = studyUidsInner?.filter(
						(x, i) => x !== firstRecord
					);
					let studyUidsList = reststudyUids.join(`|`);
					urlTemp = `${process.env.REACT_APP_VIEWER_URL}/${firstRecord}?es=${studyUidsList}&tk=${tokenApi}`;
				}
				setUrl(urlTemp);
	
				if(compare && compareStudyUidsInner?.length > 0){
					let urlExtraTemp = "";
					if (compareStudyUidsInner?.length === 1) {
						urlExtraTemp = `${process.env.REACT_APP_VIEWER_URL}/${compareStudyUidsInner[0]}?tk=${tokenApi}`;
					} else if (compareStudyUidsInner?.length >= 2) {
						let firstRecord = compareStudyUidsInner[0];
						let restcompareStudyUids = compareStudyUidsInner?.filter(
							(x, i) => i !== 0
						);
						let compareStudyUidsList = ``;
						restcompareStudyUids.forEach((x, i) =>
							i === restcompareStudyUids.length - 1
								? (compareStudyUidsList = compareStudyUidsList + x)
								: (compareStudyUidsList = compareStudyUidsList + x + `|`)
						);
						urlExtraTemp = `${process.env.REACT_APP_VIEWER_URL}/${firstRecord}?es=${compareStudyUidsList}&tk=${tokenApi}`;
					}
					setUrlExtra(urlExtraTemp);
				}
			}
			if(modeInner === ohifV3Name){
				setCompMedReady(true);
				let urlTemp = "";
				urlTemp = `${process.env.REACT_APP_VIEWER_OHIF_URL}?StudyInstanceUIDs=${studyUidsInner.join('&StudyInstanceUIDs=')}&hangingProtocolId=@ohif/mnGrid&token=${tokenApi}`;
				setUrl(urlTemp);
	
				if(compare && compareStudyUidsInner?.length > 0){
					let urlExtraTemp = "";
					urlExtraTemp = `${process.env.REACT_APP_VIEWER_OHIF_URL}?StudyInstanceUIDs=${compareStudyUidsInner.join('&StudyInstanceUIDs=')}&hangingProtocolId=@ohif/mnGrid&token=${tokenApi}`;
					
					setUrlExtra(urlExtraTemp);
				}
			}
		}
	},[tokenApi, modeInner, studyUidsInner, tenantIdInner, compareStudyUidsInner])
	
	React.useEffect(()=>{
		if(modeInner === meddreamName && studyUidsInner?.length > 0 && tokenApi?.length > 0){
			/*let extensionImg = new Image();
			extensionImg.src = "chrome-extension://lbjcocihlgjblalajbnahgdnchlmajjo/logo_16.png";
			extensionImg.onload = () => {
				alert('Extension installed')
			}
			extensionImg.onerror = () => {
				alert('No extension')
			}
*/
			//console.warn('medDream-xhrWadoGetSeries');
			var promiseList = [];
			var seriesList = [[],[]];
			var instanceList = [[],[]];
			for(var i = 0; i < studyUidsInner.length; i++){
				//new promise with params
				promiseList.push(xhrWadoGetSeries(tokenApi, studyUidsInner[i]));
			}					
			Promise.all(promiseList).then((values) => {
				let curSeries = values.map(e => e?.result).flat().filter(e => e?.Modality !== 'PR').map(e => e?.SeriesInstanceUID)?.sort();

				seriesList[0] = curSeries;

				var promiseList = [];
				for (let ind = 0; ind < values.length; ind++) {
					let filtered = values[ind].result?.filter(e => e?.Modality !== 'PR') ?? [];
					for(var i = 0; i < filtered.length; i++){
						promiseList.push(xhrWadoGetInstances(tokenApi, values[ind].studyUID, filtered[i].SeriesInstanceUID));
					}		
				}
				
				Promise.all(promiseList).then((values) => {
					instanceList[0] = values;
						
					if(compare && compareStudyUidsInner?.length > 0){
						promiseList = [];
						for(var i = 0; i < compareStudyUidsInner.length; i++){
							//new promise with params
							promiseList.push(xhrWadoGetSeries(tokenApi, compareStudyUidsInner[i]));
						}					
						Promise.all(promiseList).then((valuesInner) => {
							let curSeries = valuesInner.map(e => e?.result).flat().filter(e => e?.Modality !== 'PR').map(e => e?.SeriesInstanceUID)?.sort();
		
							seriesList[1] = curSeries;
		
							var promiseList = [];
							for (let ind = 0; ind < valuesInner.length; ind++) {
								let filtered = valuesInner[ind].result?.filter(e => e?.Modality !== 'PR');
								for(var i = 0; i < filtered.length; i++){
									promiseList.push(xhrWadoGetInstances(tokenApi, valuesInner[ind].studyUID, filtered[i].SeriesInstanceUID));
								}		
							}
							
							Promise.all(promiseList).then((valuesInnerInner) => {
								instanceList[1] = valuesInnerInner;
								setCompMedSeries(seriesList); 
								setCompMedInstances(instanceList);
							});
						});
					}
					else
					{
						setCompMedSeries(seriesList); 
						setCompMedInstances(instanceList);
					}
				});

			});
		}
	},[tokenApi, modeInner, studyUidsInner, compare, compareStudyUidsInner])
	
	React.useEffect(() => {
		//console.warn('medDream-updateLayout');
		const effectPromise = async () => {
			var seriesList = compMedSeries;
			if(tokenApi?.length && seriesList?.length > 0 && seriesList[0]?.length > 0 && (!compare || seriesList[1]?.length > 0) && allModalities?.length > 0){
				//[cols,rows]
				let totalSeries = seriesList[0].length + (seriesList[1]?.length??0);
				let defaultLayout = [Math.ceil(Math.sqrt(totalSeries)),Math.round(Math.sqrt(totalSeries))];
				
				if(seriesList[0]?.length > compMedMaxSeries){
					defaultLayout = [4,4];
				}

				if(compare){
					defaultLayout = [2,4];

					var maxSeriesTemp = Math.ceil(Math.max(seriesList[0].length, seriesList[1].length)/2);
					if(maxSeriesTemp <= Math.sqrt(compMedMaxSeries)){
						defaultLayout = [2,maxSeriesTemp];
					}
					
					let layoutCompare = [defaultLayout[0],defaultLayout[1]];
					if(seriesList[1].length <= defaultLayout[1]){
						layoutCompare[0] = 1;
					}

					setCompMedLayout({ main: defaultLayout, compare: layoutCompare });
				}
				else{
					setCompMedLayout({ main: defaultLayout, compare: [1,1]});
				}
			}
		}
		effectPromise();
	},[modalityInner, compare, allModalities, compMedSeries, tokenApi, compMedMaxSeries])
	
	React.useEffect(()=>{
		if(compMedSeries?.length > 0 && compMedSeries[0]?.length > 0){
			//console.warn('medDream-setCompMedSeriesIndex');
			let sIndex = { main: [-1,-1], compare: [-1,-1]};
			let update = false;
			sIndex.main = [0,(compMedSeries[0]?.length < compMedLayout.main[0]*compMedLayout.main[1] ? compMedSeries[0]?.length : compMedLayout.main[0]*compMedLayout.main[1]) ?? -1];
			
			if(compMedSeries[1]?.length > 0){
				sIndex.compare = [0,(compMedSeries[1]?.length < compMedLayout.compare[0]*compMedLayout.compare[1] ? compMedSeries[1]?.length : compMedLayout.compare[0]*compMedLayout.compare[1]) ?? -1];
			}
			
			setCompMedSeriesIndex(e => sIndex);
		}
		
	},[compMedLayout, compMedSeries])
		
	const resizeMedDreamEvent = React.useCallback(async (entries) => {
		entries.forEach(entry => {
			if(entry.contentRect.width > 992){
				setLayoutPanel(true);
			}
			else{
				setLayoutPanel(false);
			}
		  });
	}, []);
	const myObserver = new ResizeObserver(resizeMedDreamEvent);
		
	const [firstRunLoading, setFirstRunLoading] = React.useState(true);
	React.useEffect(() => {
		//console.warn('meddream - GET_OPENED_STUDIES RESPONSE');
		const interval = setTimeout(() => {
			if(compMedReadyCheck){
				if(!compMedReady){
					setCompMedReadyCheck(false);
					setCompMedReady(true);
				}
			}
			
			if(compMedPositionCheck){
				refreshImages();
				setFirstRunLoading(false);
			}

		}, 1000);
		const interval2 = setTimeout(() => {
			if(firstRunLoading){
				if(compMedReadyCheck){
					if(!compMedReady){
						setCompMedReadyCheck(false);
						setCompMedReady(true);
					}
				}
				
				if(compMedPositionCheck){
					refreshImages();
				}
			}
		}, 2000);
		const interval3 = setTimeout(() => {
			if(firstRunLoading){
				if(compMedReadyCheck){
					if(!compMedReady){
						setCompMedReadyCheck(false);
						setCompMedReady(true);
					}
				}
				
				if(compMedPositionCheck){
					refreshImages();
				}
			}
		}, 4000);

		return () => {
			clearInterval(interval);
			clearInterval(interval2);
			clearInterval(interval3);
		}
	}, [compMedReadyCheck, compMedReady, compMedPositionCheck, compMed, compMedMaxSeries, compMedLayout, compMedSeriesIndex, compMedInstances, url, firstRunLoading]);

	const processMedDreamEvent = React.useCallback(async (event) => {
		// Do we trust the sender of this message?  (might be
		// different from what we originally opened, for example).
		//if (event.origin !== "http://example.com")
		//return;
		if(event?.data?.actionType === "COMMUNICATION_SERVICE_READY" && document.getElementById(moduleId)?.contentWindow){
			//console.warn('meddream - COMMUNICATION_SERVICE_READY RESPONSE');
			setCompMed(document.getElementById(moduleId));
			setTimeout(() => {
				//console.warn('medDream - GET_OPENED_STUDIES CALL');
				document.getElementById(moduleId).contentWindow.postMessage({ actionType: "GET_OPENED_STUDIES" }, "*");
			}, 500);
			
			setTimeout(() => {
				setCompMedReadyCheck(true);
			}, 3000);
		}
		if(event?.data?.actionType === 'GET_OPENED_STUDIES') {
			//console.warn('meddream - GET_OPENED_STUDIES RESPONSE');
			setCompMedReady(true);
			setCompMedPositionCheck(true);
		}
	},[moduleId]);

	React.useEffect(()=>{
		let mountedRef = true;
		if(modeInner === meddreamName && studyUidsInner?.length > 0 && tokenApi?.length > 0){
			setCompMedReady(false);
			if(url?.length > 0 && document.getElementById(moduleId)?.contentWindow){
				document.getElementById(moduleId)?.contentWindow.postMessage({ actionType: "CLOSE_STUDIES" }, "*")
			}
			//console.warn('medDream-med token');
			myObserver.observe(document.getElementById(moduleId));
			var studiesList = [];
			
			for (var i = 0; i < studyUidsInner.length; i++) {
				studiesList.push({
					"studies": {
						"study": studyUidsInner[i],
						"storage": "dicomweb"+tenantIdInner
					}
				});
			}
			for (var i = 0; i < compareStudyUidsInner?.length; i++) {
				studiesList.push({
					"studies": {
						"study": compareStudyUidsInner[i],
						"storage": "dicomweb"+tenantIdInner
					}
				});
			}
			
			
		const effectPromise = async () => {
				var tokenParams = {
					"items": studiesList,
					"permissions": ["PATIENT_HISTORY"] 
				};
				if(tenantId === 34 || tenantId === 13){
					tokenParams['user'] = { id: 'mpr_user',  name: 'mpr_user'} 
				}
				var data = await xhrWadoGetToken(tokenApi, tokenParams);
				//toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				var result = data?.result;
				if (result !== null && result !== undefined && result !== "") {
					let urlTemp = `${process.env.REACT_APP_VIEWER_MEDDREAM_URL}/?token=${result}`;
					setUrl(urlTemp);
	
					
					window?.removeEventListener("message", processMedDreamEvent);
					window?.addEventListener("message", processMedDreamEvent, false);
	
				}
			}
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	},[tokenApi, modeInner, moduleId, studyUidsInner, tenantIdInner, compareStudyUidsInner])
	
	const delay = ms => new Promise(res => setTimeout(res, ms));

	React.useEffect(()=>{
		
		// declare the async data fetching function
		const setMedDreamLayout = async () => {
			if(compMedReady && (compMedInstances?.length > 0 && compMedInstances[0]?.length > 0 && compMedSeriesIndex.main[1] >= 0) 
				&& (!compare || (compMedInstances[1]?.length > 0 && compMedSeriesIndex.compare[1] >= 0)) && compMed){
					
				//console.warn('medDream - SET_LAYOUT');
				//console.warn(compMedLayout);

				if(compare){
					compMed.contentWindow.postMessage({ actionType: "SET_LAYOUT", actionData: {columns: compMedLayout.main[0]+compMedLayout.compare[0], rows: compMedLayout.main[1]} }, "*");
				}
				else
				{
					compMed.contentWindow.postMessage({ actionType: "SET_LAYOUT", actionData: {columns: compMedLayout.main[0], rows: compMedLayout.main[1]} }, "*");
				}

				setCompMedPositionCheck(true);
			}
	  
		}
	  
		// call the function
		setMedDreamLayout();

	},[compMedReady, compMed, compare, compMedLayout, compMedInstances, compMedSeriesIndex])
	
	const refreshImages = React.useCallback(async () => {
		
		const refreshImagesInner = async () => {
			if(!(url?.length > 0) || !compMedReady || !(compMed?.contentWindow)){
				return;
			}
			var indexRow = 1;
			var indexCol = 1;
			console.warn('meddream - OPEN:');
			for(var i = 0; (i < compMedInstances[0].length); i++){//
				if(i < compMedInstances[0]?.length && i >= compMedSeriesIndex.main[0] && i < compMedSeriesIndex.main[1] && (indexRow * indexCol) <= compMedMaxSeries){
					var seriesTemp = compMedInstances[0][i].sort((a, b) => (b.InstanceNumber === a.InstanceNumber) ? a.SOPInstanceUID.localeCompare(b.SOPInstanceUID) : a.InstanceNumber - b.InstanceNumber).map(e => e.SOPInstanceUID);
					var mDreamParams =  { instanceUid: (seriesTemp[0]), viewportColumn: indexCol, viewportRow: indexRow, viewportActions: { windowing: "DICOM" } };
					
					console.warn('meddream - Instance Main - series:'+i+',vRow:'+indexRow+',vCol:'+indexCol, ',inst:' + (seriesTemp[0]));
					
					compMed.contentWindow.postMessage({ actionType: "OPEN_INSTANCE", actionData: mDreamParams }, "*");
					await delay(100);
					indexCol++;
					if(((indexCol-1) % (compMedLayout.main[0])) === 0)
					{
						indexCol = 1;
						indexRow++;
					}
				}
				else{
					//console.warn('Clean pos vRow:'+indexRow+',vCol:'+indexCol);
					//compMed.contentWindow.postMessage({ actionType: "OPEN_INSTANCE", actionData: { instanceUid: '', viewportColumn: indexCol, viewportRow: indexRow, viewportActions: { windowing: "AUTO" } } }, "*");
				}
					
			}
			indexRow = 1;
			indexCol = (compMedLayout.main[0]+1);
			for(var i = 0; (i < compMedInstances[1].length); i++){
				if(i >= compMedSeriesIndex.compare[0] && i < compMedSeriesIndex.compare[1] && (indexRow * indexCol) <= compMedMaxSeries){
					var seriesTemp1 = compMedInstances[1][i].sort((a, b) => (b.InstanceNumber === a.InstanceNumber) ? a.SOPInstanceUID.localeCompare(b.SOPInstanceUID) : a.InstanceNumber - b.InstanceNumber).map(e => e.SOPInstanceUID);
					var mDreamParams1 =  { instanceUid: (seriesTemp1[0]), viewportColumn: indexCol, viewportRow: indexRow, viewportActions: { windowing: "AUTO" } };
					
					//console.warn('meddream - Instance Compare - series:'+i+',vRow:'+indexRow+',vCol:'+indexCol);
					
					compMed.contentWindow.postMessage({ actionType: "OPEN_INSTANCE", actionData: mDreamParams1 }, "*");
					await delay(100);
					
					indexCol++;
					if(((indexCol-1) % (compMedLayout.main[0] + compMedLayout.compare[0])) === 0)
					{
						indexCol = (compMedLayout.main[0]+1);
						indexRow++;
					}
				}
			}
		}
		// call the function
		refreshImagesInner();

	},[compMed, compMedMaxSeries, compMedLayout, compMedSeriesIndex, compMedInstances, compMedReady, url]);

	const comMedPreviousSeries = () => {
		if((compMedSeriesIndex.main[0]+1) > 1){
			let sIndex = JSON.parse(JSON.stringify(compMedSeriesIndex));
			sIndex.main = [sIndex.main[0]-1,sIndex.main[1]-1];
			setCompMedSeriesIndex(e => sIndex);
			/*setTimeout(() => {
				refreshImages();
			}, 100);*/
		}
	}

	const comMedNextSeries = () => {
		if((compMedSeriesIndex.main[1]) < compMedSeries[0].length){
			let sIndex = JSON.parse(JSON.stringify(compMedSeriesIndex));
			sIndex.main = [sIndex.main[0]+1,sIndex.main[1]+1];
			setCompMedSeriesIndex(e => sIndex);
			/*setTimeout(() => {
				refreshImages();
			}, 100);*/
		}
	}

	const comMedPreviousSeriesCompare = () => {
		if((compMedSeriesIndex.compare[0]+1) > 1){
			let sIndex = JSON.parse(JSON.stringify(compMedSeriesIndex));
			sIndex.compare = [sIndex.compare[0]-1,sIndex.compare[1]-1];
			setCompMedSeriesIndex(e => sIndex);
			/*setTimeout(() => {
				refreshImages();
			}, 100);*/
		}
	}

	const comMedNextSeriesCompare = () => {
		if((compMedSeriesIndex.compare[1]) < compMedSeries[1].length){
			let sIndex = JSON.parse(JSON.stringify(compMedSeriesIndex));
			sIndex.compare = [sIndex.compare[0]+1,sIndex.compare[1]+1];
			setCompMedSeriesIndex(e => sIndex);
			/*setTimeout(() => {
				refreshImages();
			}, 100);*/
		}
	}
	
	const handleOnMouseOver = () => {
		//console.log('handleOnMouseOver');
	};
	
	const handleOnMouseOut = () => {
		//console.log('handleOnMouseOut');
	};
	const handleOnBlur = React.useCallback(async (e) => {
		//ignore blur if devexpress editor
		if(modeInner === meddreamName && ! (document?.activeElement?.contentDocument?.location?.pathname === 'blank' &&
		document?.activeElement?.nodeName === 'IFRAME')){
			document.dispatchEvent(
				new CustomEvent("medapp_audio_enable_extension", {
				bubbles: true,
				detail: { status: true},
				})
			);
		}
	}, [modeInner, moduleId]);
	
	const handleOnFocus = React.useCallback(async (e) => {
		if(modeInner === meddreamName){
			if (document?.activeElement?.id === moduleId) {
				document.dispatchEvent(
					new CustomEvent("medapp_audio_enable_extension", {
					bubbles: true,
					detail: { status: true},
					})
				);
			}
			else{
				document.dispatchEvent(
					new CustomEvent("medapp_audio_enable_extension", {
					bubbles: true,
					detail: { status: false},
					})
				);
			}
		}
	}, [moduleId, modeInner]);
	
	React.useEffect(() => {
		window.addEventListener('blur', handleOnBlur);
		window.addEventListener('focus', handleOnFocus);
		return () => {
			window.removeEventListener('blur', handleOnBlur);
			window.removeEventListener('focus', handleOnFocus);
		};	
	}, []);

	const arrayRowCol = [1,2,3,4,5,6];

	return(
		<div style={{ display: 'flex', flexDirection: 'column', width: "100%", height: "100%" }}>
			<div style={{ flex: '1', display: 'flex', flexDirection: 'row' }}>
				<div style={{ flex: '1', display: (compMedReady ? 'block' : 'none') }}>
					<iframe key={moduleId} id={moduleId} src={url} frameBorder="none" style={{ width: "100%", height: "100%", borderRight:'2px solid #eee' }} 
						onMouseOver={handleOnMouseOver}
						onMouseOut={handleOnMouseOut}
						onFocus={handleOnFocus}
						onBlur={handleOnBlur}
					/>
				</div>
				<div style={{ flex: '1', display: (!compMedReady ? 'flex' : 'none'), flexDirection: 'row', background: 'white', paddingTop: '30vh', textAlign: 'center' }}>
					<div style={{flex: '1'}}></div>
					<div style={{flex: '0', minWidth: '200px', fontSize: 'x-large'}}>
						<label style={{ 
							float: 'left',
							marginRight: '10px',
							}}>Loading Images</label>
						<div style={{ 
							animation: 'spinner-border 1000ms infinite linear', 
							width: 'fit-content' , 
							float: 'left',
							}}>
						<i className="zmdi zmdi-refresh" ></i>
						</div>
					</div>
					<div style={{flex: '1'}}></div>
				</div>
				{ (compare && modeInner === ohifName && compMedReady) && (
					<div style={{ flex: '1' }}>
						<iframe key={moduleId+'extra'} id={moduleId+'extra'} src={urlExtra} frameBorder="none" style={{ width: "100%", height: "100%" }}/>
					</div>
				)}
			</div>
			
			<div style={{ display: (modeInner === meddreamName && compMedReady ? 'block' : 'none'), position:'absolute', paddingTop: '12px', width: '250px', height: '65px',  background: '#27272b', color:'white', bottom: (layoutPanel ? 'auto' : '0'), right: (layoutPanel ? 'auto' : '0')}}>
				<div onClick={async () => { setLayoutSelector(e => !e); }} 
					style={{ backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0iI2QwZDBkMCI+PHBhdGggZD0iTTYxIDE3LjhjLS4zLjgtLjkgMS0xLjcgMUg0Ni45Yy0xLjIgMC0xLjctLjUtMS43LTEuN1Y0LjdjMC0uOC4zLTEuNCAxLTEuN2gxMy45bC45Ljl2MTMuOXpNNDYuMiA2MWMtLjctLjMtMS0uOS0xLTEuN1Y0Ni45YzAtMS4yLjUtMS43IDEuNy0xLjdoMTIuNGMuOCAwIDEuNC4yIDEuNyAxdjEzLjlsLS45LjlINDYuMnpNMyA0Ni4yYy4zLS44LjktMSAxLjctMWgxMi40YzEuMiAwIDEuNy41IDEuNyAxLjd2MTIuNGMwIC44LS4zIDEuNC0xIDEuN0gzLjlsLS45LS45VjQ2LjJ6TTM5IDNjLjcuNC45IDEgLjkgMS44djEyLjNjMCAxLjItLjUgMS43LTEuNyAxLjdIMjUuOGMtMS4yIDAtMS43LS41LTEuNy0xLjdWNC44YzAtLjguMi0xLjQuOS0xLjhoMTR6TTMgMjVjLjQtLjcgMS0uOSAxLjgtLjloMTIuM2MxLjIgMCAxLjcuNSAxLjcgMS43djEyLjVjMCAxLjItLjUgMS43LTEuNiAxLjdINC45Yy0uOS0uMS0xLjUtLjMtMS45LTFWMjV6bTU4IDE0Yy0uNC43LTEgLjktMS44LjlINDYuOWMtMS4yIDAtMS43LS41LTEuNy0xLjdWMjUuOGMwLTEuMi41LTEuNyAxLjctMS43aDEyLjNjLjggMCAxLjQuMiAxLjguOXYxNHpNMjUgNjFjLS43LS40LS45LTEtLjktMS44VjQ2LjljMC0xLjIuNS0xLjcgMS43LTEuN2gxMi40YzEuMiAwIDEuNy41IDEuNyAxLjd2MTIuM2MwIC44LS4yIDEuNC0uOSAxLjhIMjV6TTE3LjggM2MuOC4zIDEgLjkgMSAxLjd2MTIuNGMwIDEuMi0uNSAxLjctMS43IDEuN0g0LjdjLS44IDAtMS40LS4yLTEuNy0xVjMuOWwuOS0uOWgxMy45ek0zMiAzOS45aC02LjJjLTEuMiAwLTEuNi0uNS0xLjYtMS43VjI1LjdjMC0xLjIuNS0xLjcgMS42LTEuN2gxMi42YzEuMSAwIDEuNi41IDEuNiAxLjZ2MTIuNmMwIDEuMS0uNSAxLjYtMS42IDEuNi0yLjIuMS00LjMuMS02LjQuMXoiLz48L3N2Zz4=")', 
					float: 'right', marginRight: '15px', width: '30px', height: '30px'}}><label id="" style={{ position: 'absolute', right: '15px', top: '40px', fontSize: '10px' }}>Layout</label></div>
				<div className="medDreamLyoutPicker" style={{ display: layoutSelector ? 'block' : 'none', 
						border: '1px solid grey', background: 'rgb(39, 39, 43)', borderRadius: '3px', top: (layoutPanel ? '60px' : '-180px') }}>
					{ 	arrayRowCol.map((lpickCols)=>{
							return (
							<div className="medDreamLyoutPickerRow" key={'medDreamLyoutPickerRow-'+lpickCols}>{
								arrayRowCol.map((lpickRows)=>{
									let hoverA = (compare ? Math.ceil(compMedLayoutHover[0]/2) : compMedLayoutHover[0] ) >= lpickCols && compMedLayoutHover[1] >= lpickRows;
									let hoverB = (compare ? (compMedLayoutHover[0] >= lpickCols && Math.ceil(compMedLayoutHover[0]/2) < lpickCols) : false )  && compMedLayoutHover[1] >= lpickRows;
									let allow = (lpickCols * lpickRows <= compMedMaxSeries);
									let selectedA = lpickCols <= compMedLayout.main[0] && lpickRows <= compMedLayout.main[1];
									let selectedB = compare && lpickCols <= (compMedLayout.main[0] + compMedLayout.compare[0]) && lpickRows <= compMedLayout.compare[1];
									let backColor = 'gray';
									
									if (hoverB) {
										backColor = 'darkseagreen';
									}
									else
									if(hoverA){
										backColor = 'gold';
									}
									else
									if(selectedA)
									{
										backColor = 'darkorange';
									}
									else
									if(selectedB)
									{
										backColor = 'darkgreen';
									}
									else
									if(allow)
									{
										backColor = 'white';
									}
									
									return (
										<div className="medDreamLyoutPickerCol" key={'medDreamLyoutPickerCol-'+lpickRows+'-'+lpickRows}
										title={ allow ? ' ' : 'Max Series:'+ compMedMaxSeries }
										style={{ backgroundColor: backColor}}
										onClick={ async (e) => { 
											if(!allow){
												return;
											}
											compMed.contentWindow.postMessage({ actionType: "SET_LAYOUT", actionData: {columns: 1, rows: 1} }, "*");
											await delay(500);
											
											if(!compare){
												setCompMedLayout({ main: [lpickCols,lpickRows], compare: [1,1]}); 
											}
											else{
												setCompMedLayout({ main: [Math.ceil(lpickCols/2),lpickRows], compare: [Math.floor(lpickCols/2),lpickRows] }); 
											}
											setLayoutSelector(false);
										}} 
										onMouseEnter={ (e) => { 
											setCompMedLayoutHover([lpickCols,lpickRows]); 
										}}>
										</div>
									);
									
								})
							}
							</div>);
						})
					}
					<div style={{ marginLeft: '40px'}}>{compMedLayoutHover[0]} x {compMedLayoutHover[1]}</div>
				</div>
				{ (compare && modeInner === meddreamName && compMedSeries?.length > 0) && (
				<div style={{float: 'right', fontSize: '12px', textAlign: 'center' }}>
					<label style={{  }}>Series B { '[' + compMedSeries[1].length + ']'} </label>
					<div style={{ textAlign: 'center' }}></div>
					<button style={{ width:'2em', marginRight: '0.1em', color:'orange', padding: '0em 0.3em', marginTop: '2px', background: 'transparent', border: 0 }} onClick={comMedPreviousSeriesCompare}>{'<<'}</button>
					<label style={{ left:'30%', marginRight: '0.1em' }}>{compMedSeriesIndex.compare[0]+1} - {compMedSeriesIndex.compare[1]}</label>
					<button style={{ width:'2em', color:'orange', padding: '0em 0.3em', marginTop: '2px', background: 'transparent', border: 0 }} onClick={comMedNextSeriesCompare}>{'>>'}</button>
				</div>
				)}
				<div style={{float: 'right', fontSize: '12px', textAlign: 'center' }}>
					<label style={{  }}>Series {compare ? 'A' : ''} { '[' + compMedSeries[0].length + ']'} </label>
					<div style={{ textAlign: 'center' }}></div>
					<button style={{ width:'2em', marginRight: '0.1em', color:'orange', padding: '0em 0.3em', marginTop: '2px', background: 'transparent', border: 0 }} onClick={comMedPreviousSeries}>{'<<'}</button>
					<label style={{ left:'30%', marginRight: '0.1em' }}>{compMedSeriesIndex.main[0]+1} - {compMedSeriesIndex.main[1]}</label>
					<button style={{ width:'2em', color:'orange', padding: '0em 0.3em', marginTop: '2px', background: 'transparent', border: 0 }} onClick={comMedNextSeries}>{'>>'}</button>
				</div>
			</div>
		</div>
			
		);
};

export default DicomViewer;
